// extracted by mini-css-extract-plugin
export default {"workspaceName":"SettingsPageWorkspaceSettings_workspaceName__Idfbz"};